import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import ErrorBoundary from './components/common/ErrorBoundary';
import { initBrowserSentry } from './lib/sentry';
import { installStaleChunkReload } from './lib/staleChunkReload';
import { queryClient } from './lib/queryClient';
import './app.css';

// Phase 25.5b-2 — initialize Sentry BEFORE the first React render so
// ErrorBoundary / captureException calls have a live transport. No-op
// when VITE_SENTRY_DSN is unset (dev default).
initBrowserSentry();

// Recover a tab that was open across a deploy and is now asking for
// chunk files that no longer exist. Registered after Sentry so its
// reports have a transport, and before render so a preload failure
// during the first navigation is already covered.
installStaleChunkReload();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </ErrorBoundary>
  </StrictMode>,
);
